export const cardWrapper = 'card-wrapper';
export const card = 'card';
